import React, { Component } from "react";
import _ from "lodash";

export default class TableBody extends Component {
  renderCell = (item, column) => {
    if (column.content) {
      return column.content(item);
    }
    return _.get(item, column.path);
  };
  render() {
    return (
      <tbody>
        {this.props.data.map((item) => (
          <tr
            onClick={() => this.props.onClickRow(item)}
            key={item.id || item.firstName}
          >
            {this.props.columns.map((column) => (
              <td key={column.id}>{this.renderCell(item, column)}</td>
            ))}
          </tr>
        ))}
      </tbody>
    );
  }
}
